import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-social-yatay01',
  templateUrl: './social-yatay01.component.html',
  styleUrls: ['./social-yatay01.component.scss']
})
export class SocialYatay01Component implements OnInit {
  isVisible = false;
  @Input() sosyalMedya:any[] = [];
  constructor(private http:HttpClient) {
     /*  http.get('https://api.tv264.gunesozturk.com/api/sosyalmedya/front',
      { headers: { 'Authorization': 'Basic ' + 'YWRtaW46ZGlnaXNvZnQ='} }).subscribe((resp:any[])=>{
       // console.log('Sosyal' , resp)
        this.sosyalMedya = resp;
      })   */
   }


   showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    console.log('Button ok clicked!');
    this.isVisible = false;
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isVisible = false;
  }
  ngOnInit() {
  }

}
